/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CheckboxInput from 'components/input/CheckboxInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import SelectInput from 'components/input/SelectInput';
import { BoolToString, formatBoolean, optionValues } from 'components/helper/helper';
import GroupRadioButton from 'components/input/GroupRadioButton';
import ReuseFieldScoreAndDate from '../IELTSAndPTE/components/ReuseFieldScoreAndDate';
import { getTOEFL, updateTOEFL } from 'app/testingSlice/testingSlice';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import { Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TextInput from 'components/input/textInput';
import DatePickerInput from 'components/input/DatePicker';
import { debounce } from 'lodash';
import Grid from '@mui/joy/Grid';
import { getAccessToken, getUserId } from 'utils/sessionStorage';
import { removeAccessToken, removeUserId } from 'utils/sessionStorage';
//import Cookies from 'js-cookie';
//import { authenticateSettings } from 'components/helper/appConfig';

interface Props {}

const TOEFL = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing = useAppSelector((store) => store.testing);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const formik = useFormik({
    initialValues: {
      // New field -------
      toefl_ibt_registration_number: '',
      toefl_ibt_received_score: '',
      toefl_ibt_reading_score: '',
      toefl_ibt_listening_score: '',
      toefl_ibt_writing_score: '',
      toefl_ibt_speaking_score: '',
      toefl_ibt_plan_on_retake: '',
      toefl_ibt_date_retake: '',
      toefl_paper_registration_number: '',
      toefl_paper_highest_twe_score: '',
      toefl_paper_twe_date_taken: '',
      toefl_paper_received_score: '',
      toefl_paper_reading_score: '',
      toefl_paper_listening_score: '',
      toefl_paper_writing_score: '',
      toefl_paper_plan_on_retake: '',
      toefl_paper_date_retake: '',
      // New field -------
      is_not_required_toefl_test: true,
      is_considered_international_student: '',
      number_of_time_taken_toefl_ibt: 0,
      number_of_future_toefl_ibt_expect: '0',
      toefl_ibt_highest_reading_score: '',
      toefl_ibt_reading_date_taken: '',
      toefl_ibt_highest_speaking_score: '',
      toefl_ibt_speaking_date_taken: '',
      toefl_ibt_highest_listening_score: '',
      toefl_ibt_listening_date_taken: '',
      toefl_ibt_highest_writing_score: '',
      toefl_ibt_writing_date_taken: '',
      toefl_ibt_highest_total_score: '',
      toefl_ibt_total_score_date_taken: '',
      number_of_time_taken_toefl_paper: 0,
      number_of_future_toefl_paper_expect: '0',
      toefl_paper_highest_reading_score: '',
      toefl_paper_reading_date_taken: '',
      toefl_paper_highest_speaking_score: '',
      toefl_paper_speaking_date_taken: '',
      toefl_paper_highest_listening_score: '',
      toefl_paper_listening_date_taken: '',
      toefl_paper_highest_writing_score: '',
      toefl_paper_writing_date_taken: '',
      toefl_paper_highest_total_score: '',
      toefl_paper_total_score_date_taken: '',
    },
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        is_considered_international_student: formatBoolean(
          values.is_considered_international_student
        ),
        student_id: studentId,
      };
      await dispatch(updateTOEFL(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('toeflTest') && testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      let res = await dispatch(getTOEFL(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = {
          ...dataLoaded,
          is_considered_international_student: BoolToString(
            dataLoaded.is_considered_international_student
          ),
          number_of_future_toefl_ibt_expect:
            dataLoaded.number_of_future_toefl_ibt_expect.toString(),
          number_of_future_toefl_paper_expect:
            dataLoaded.number_of_future_toefl_paper_expect.toString(),
        };
        formik.setValues({ ...formik.values, ...values });
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    if (formik.values.toefl_ibt_received_score === 'false') {
      formik.setValues({
        ...formik.values,
        toefl_ibt_highest_reading_score: '',
        toefl_ibt_reading_date_taken: '',
        toefl_ibt_speaking_date_taken: '',
        toefl_ibt_highest_speaking_score: '',
        toefl_ibt_highest_listening_score: '',
        toefl_ibt_listening_date_taken: '',
        toefl_ibt_highest_writing_score: '',
        toefl_ibt_writing_date_taken: '',
        toefl_ibt_highest_total_score: '',
        toefl_ibt_total_score_date_taken: '',
        toefl_ibt_listening_score: '',
        toefl_ibt_reading_score: '',
        toefl_ibt_writing_score: '',
        toefl_ibt_speaking_score: '',
      });
    }
  }, [formik.values.toefl_ibt_received_score]);
  // Auto save function ==========
  const notInitialRender = React.useRef(false);
  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (notInitialRender.current) {
        if (!loading) formik.handleSubmit();
      } else {
        notInitialRender.current = true;
      }
    }, 1500),
    []
  );
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'General', percentOnProcess: 20 },
          { title: 'TOEFL iBT', percentOnProcess: 50 },
          { title: 'TOEFL Paper', percentOnProcess: 80 },
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                TOEFL Tests
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              {/* General Section */}
              <Grid xs={12}>
                <div className="gm-section-subtitle mb-3">
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography className="fs-6 text-dark my-2 fw-bold">
                          <InfoOutlinedIcon fontSize="small" className="mx-1" />
                          TOEFL Test
                        </Typography>
                        <div className="d-flex flex-wrap text-field-light">
                          For international students - the testing policies for specific colleges can
                          vary. Check with the colleges you intend to apply to in advance to determine the
                          tests, if any, you'll need to take. Note, be sure to do in your 1st or 2nd year
                          of high school so you can plan accordingly when to take your test(s).
                        </div>
                      </React.Fragment>
                    }
                    placement="right-start"
                  >
                    <div className="text-field-mid fs-4 mb-3 fw-bold" id="General">General</div>
                  </HtmlTooltip>
                </div>
              </Grid>

              <Grid xs={12}>
                <CheckboxInput
                  onChange={formik.handleChange}
                  name="is_not_required_toefl_test"
                  values={formik.values.is_not_required_toefl_test}
                  label="I'm a domestic student or am not required to take the TOEFL Tests."
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Are you considered an International Student or have recently started high school in the U.S.?"
                  disabled={formik.values.is_not_required_toefl_test}
                  values={formik.values.is_considered_international_student}
                  onChange={formik.handleChange}
                  name="is_considered_international_student"
                />
              </Grid>

              {/* TOEFL iBT Section */}
              <Grid xs={12}>
                <div className="border-top pt-4 mt-4">
                  <div className="gm-section-subtitle mb-3">
                    <div className={`text-field-mid ${isMobile ? 'fs-6' : 'fs-4'} mb-3 fw-bold`} id="TOEFLiBT">TOEFL iBT</div>
                  </div>
                </div>
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <SelectInput
                  form={formik}
                  disabled={formik.values.is_not_required_toefl_test}
                  label="Number of times you have already taken the TOEFL iBT*"
                  option={optionValues(Array.from({ length: 5 }, (_, i) => i + 1))}
                  name="number_of_time_taken_toefl_ibt"
                  values={formik.values.number_of_time_taken_toefl_ibt}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  label="Registration number *"
                  name="toefl_ibt_registration_number"
                  countText={7}
                  values={formik.values.toefl_ibt_registration_number}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Have you received your scores yet? *"
                  name="toefl_ibt_received_score"
                  values={formik.values.toefl_ibt_received_score}
                  onChange={formik.handleChange}
                />
              </Grid>

              {formik.values.toefl_ibt_received_score === 'true' && (
                <>
                  <Grid xs={12}>
                    <ReuseFieldScoreAndDate
                      selectOptions={optionValues(Array.from(Array(31).keys()))}
                      disabled={formik.values.is_not_required_toefl_test}
                      formik={formik}
                      isMobile={isMobile}
                      arrayName={[
                        {
                          fieldName: 'toefl_ibt_highest_reading_score',
                          dateName: 'toefl_ibt_reading_date_taken',
                          label: 'reading',
                        },
                        {
                          fieldName: 'toefl_ibt_highest_speaking_score',
                          dateName: 'toefl_ibt_speaking_date_taken',
                          label: 'speaking',
                        },
                        {
                          fieldName: 'toefl_ibt_highest_listening_score',
                          dateName: 'toefl_ibt_listening_date_taken',
                          label: 'listiening',
                        },
                        {
                          fieldName: 'toefl_ibt_highest_writing_score',
                          dateName: 'toefl_ibt_writing_date_taken',
                          label: 'writing',
                        },
                      ]}
                    />
                  </Grid>

                  <Grid xs={isMobile ? 12 : 6}>
                    <TextInput
                      type="number"
                      max={999}
                      label="Highest TOEFL iBT total score*"
                      name={`toefl_ibt_highest_total_score`}
                      values={formik.values.toefl_ibt_highest_total_score}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                  <Grid xs={isMobile ? 12 : 6}>
                    <DatePickerInput
                      label="Date taken"
                      name={`toefl_ibt_total_score_date_taken`}
                      values={formik.values.toefl_ibt_total_score_date_taken}
                      onChange={(values) =>
                        formik.setFieldValue('toefl_ibt_total_score_date_taken', values)
                      }
                    />
                  </Grid>

                  <Grid xs={isMobile ? 12 : 6}>
                    <TextInput
                      type="number"
                      max={30}
                      name="toefl_ibt_listening_score"
                      values={formik.values.toefl_ibt_listening_score}
                      onChange={formik.handleChange}
                      label="Listening *"
                    />
                  </Grid>
                  <Grid xs={isMobile ? 12 : 6}>
                    <TextInput
                      type="number"
                      max={30}
                      name="toefl_ibt_reading_score"
                      values={formik.values.toefl_ibt_reading_score}
                      onChange={formik.handleChange}
                      label="Reading *"
                    />
                  </Grid>
                  <Grid xs={isMobile ? 12 : 6}>
                    <TextInput
                      type="number"
                      max={30}
                      name="toefl_ibt_writing_score"
                      values={formik.values.toefl_ibt_writing_score}
                      onChange={formik.handleChange}
                      label="Writing *"
                    />
                  </Grid>
                  <Grid xs={isMobile ? 12 : 6}>
                    <TextInput
                      type="number"
                      max={30}
                      name="toefl_ibt_speaking_score"
                      values={formik.values.toefl_ibt_speaking_score}
                      onChange={formik.handleChange}
                      label="Speaking*"
                    />
                  </Grid>
                </>
              )}

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Do you plan on retaking this test? *"
                  values={formik.values.toefl_ibt_plan_on_retake}
                  onChange={formik.handleChange}
                  name="toefl_ibt_plan_on_retake"
                />
              </Grid>

              {formik.values.toefl_ibt_plan_on_retake === 'true' && (
                <>
                  <Grid xs={isMobile ? 12 : 6}>
                    <GroupRadioButton
                      label="Number of future TOEFL iBT sittings you expect*"
                      options={['0', '1', '2', '3']}
                      values={formik.values.number_of_future_toefl_ibt_expect}
                      onChange={formik.handleChange}
                      name="number_of_future_toefl_ibt_expect"
                      disabled={formik.values.is_not_required_toefl_test}
                    />
                  </Grid>
                  {formik.values.number_of_future_toefl_ibt_expect !== '0' && (
                    <Grid xs={isMobile ? 12 : 6}>
                      <DatePickerInput
                        label="When will you retake this test? *"
                        name={`toefl_ibt_date_retake`}
                        values={formik.values.toefl_ibt_date_retake}
                        onChange={(values) => formik.setFieldValue('toefl_ibt_date_retake', values)}
                      />
                    </Grid>
                  )}
                </>
              )}
              
              {/* TOEFL Paper Section */}
              <Grid xs={12}>
                <div className="border-top pt-4 mt-4">
                  <div className="gm-section-subtitle mb-3">
                    <div className={`text-field-mid ${isMobile ? 'fs-6' : 'fs-4'} mb-3 fw-bold`} id="TOEFLPaper">TOEFL Paper</div>
                  </div>
                </div>
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <SelectInput
                  form={formik}
                  disabled={formik.values.is_not_required_toefl_test}
                  label="Number of times you have already taken the TOEFL Paper?* "
                  option={optionValues(Array.from({ length: 5 }, (_, i) => i + 1))}
                  name="number_of_time_taken_toefl_paper"
                  values={formik.values.number_of_time_taken_toefl_paper}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  label="Registration number *"
                  name="toefl_paper_registration_number"
                  countText={7}
                  values={formik.values.toefl_paper_registration_number}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={12}>
                <ReuseFieldScoreAndDate
                  selectOptions={optionValues(Array.from(Array(100).keys()))}
                  disabled={formik.values.is_not_required_toefl_test}
                  formik={formik}
                  isMobile={isMobile}
                  arrayName={[
                    {
                      fieldName: 'toefl_paper_highest_reading_score',
                      dateName: 'toefl_paper_reading_date_taken',
                      label: 'reading',
                    },
                    {
                      fieldName: 'toefl_paper_highest_speaking_score',
                      dateName: 'toefl_paper_speaking_date_taken',
                      label: 'speaking',
                    },
                    {
                      fieldName: 'toefl_paper_highest_listening_score',
                      dateName: 'toefl_paper_listening_date_taken',
                      label: 'listiening',
                    },
                    {
                      fieldName: 'toefl_paper_highest_writing_score',
                      dateName: 'toefl_paper_writing_date_taken',
                      label: 'writing',
                    },
                    {
                      fieldName: 'toefl_paper_highest_twe_score',
                      dateName: 'toefl_paper_twe_date_taken',
                      label: 'TWE',
                      options: optionValues(Array.from({ length: 7 }, (_, i) => i)),
                    },
                  ]}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  max={999}
                  label="Highest TOEFL Paper total score*"
                  name={`toefl_paper_highest_total_score`}
                  values={formik.values.toefl_paper_highest_total_score}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <DatePickerInput
                  label="Date taken"
                  name={`toefl_paper_total_score_date_taken`}
                  values={formik.values.toefl_paper_total_score_date_taken}
                  onChange={(values) =>
                    formik.setFieldValue('toefl_paper_total_score_date_taken', values)
                  }
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  max={30}
                  name="toefl_paper_listening_score"
                  values={formik.values.toefl_paper_listening_score}
                  onChange={formik.handleChange}
                  label="Listening *"
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  max={30}
                  name="toefl_paper_reading_score"
                  values={formik.values.toefl_paper_reading_score}
                  onChange={formik.handleChange}
                  label="Reading *"
                />
              </Grid>
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  max={30}
                  name="toefl_paper_writing_score"
                  values={formik.values.toefl_paper_writing_score}
                  onChange={formik.handleChange}
                  label="Writing *"
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Do you plan on retaking this test? *"
                  values={formik.values.toefl_paper_plan_on_retake}
                  onChange={formik.handleChange}
                  name="toefl_paper_plan_on_retake"
                />
              </Grid>

              {formik.values.toefl_paper_plan_on_retake === 'true' && (
                <>
                  <Grid xs={isMobile ? 12 : 6}>
                    <GroupRadioButton
                      label="Number of future TOEFL iBT sittings you expect*"
                      options={['0', '1', '2', '3']}
                      values={formik.values.number_of_future_toefl_paper_expect}
                      onChange={formik.handleChange}
                      name="number_of_future_toefl_paper_expect"
                      disabled={formik.values.is_not_required_toefl_test}
                    />
                  </Grid>
                  {formik.values.number_of_future_toefl_paper_expect !== '0' && (
                    <Grid xs={isMobile ? 12 : 6}>
                      <DatePickerInput
                        label="When will you retake this test? *"
                        name={`toefl_paper_date_retake`}
                        values={formik.values.toefl_paper_date_retake}
                        onChange={(values) =>
                          formik.setFieldValue('toefl_paper_date_retake', values)
                        }
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-end'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default TOEFL;
